module.exports = __webpack_public_path__ + "img/554-1b5a60.png";